export default __webpack_public_path__ + "static/media/transito.ef1dece2.svg";